import { useState } from "react";
import { useTranslate } from "@refinedev/core";

import { UseAgreementTokenModalControllerProps } from "./types";

export function useAgreementTokenModalController({
  token
}: UseAgreementTokenModalControllerProps) {
  const [openSnackbar, setOpenSnackbar] = useState(false);
  const translate = useTranslate();

  const handleCopy = () => {
    if (token) {
      navigator.clipboard.writeText(token);
      setOpenSnackbar(true);
    }
  };

  const handleCloseSnackbar = () => {
    setOpenSnackbar(false);
  };

  return {
    openSnackbar,
    translate,
    handleCopy,
    handleCloseSnackbar,
  };
}
